import {
  PLAYER_Y,
  SPREAD_BULLET_VX,
} from './gameUtils';

const DEFAULT_SHOT_COOLDOWN_MS = 230;
const RAPID_FIRE_COOLDOWN_MS = 110;

export function createAutoFireBursts(game, nextBulletId) {
  const primaryBullet = {
    id: nextBulletId,
    x: game.playerX,
    y: (game.playerY ?? PLAYER_Y) - 30,
  };
  let bullets = [primaryBullet];
  let bulletId = nextBulletId + 1;

  if (game.spreadShotMs > 0) {
    bullets = [
      primaryBullet,
      { ...primaryBullet, id: bulletId, vx: -SPREAD_BULLET_VX },
      { ...primaryBullet, id: bulletId + 1, vx: SPREAD_BULLET_VX },
    ];
    bulletId += 2;
  }

  if (game.optionDroneMs > 0) {
    bullets = bullets.concat([
      {
        id: bulletId,
        x: Math.max(18, game.playerX - 28),
        y: (game.playerY ?? PLAYER_Y) - 18,
      },
      {
        id: bulletId + 1,
        x: Math.min(342, game.playerX + 28),
        y: (game.playerY ?? PLAYER_Y) - 18,
      },
    ]);
    bulletId += 2;
  }

  return {
    bullets,
    nextBulletId: bulletId,
    cooldownMs: game.rapidFireMs > 0 ? RAPID_FIRE_COOLDOWN_MS : DEFAULT_SHOT_COOLDOWN_MS,
  };
}
